import { render } from "./PointInfo.vue?vue&type=template&id=f8f3b244&scoped=true"
import script from "./PointInfo.vue?vue&type=script&lang=js"
export * from "./PointInfo.vue?vue&type=script&lang=js"

import "./PointInfo.vue?vue&type=style&index=0&id=f8f3b244&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f3b244"]])

export default __exports__